'use client';

import { useState, useEffect } from 'react';
import type { SVGProps } from 'react';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import { useFirestore } from '@/firebase';
import { doc, getDoc } from 'firebase/firestore';

// Default fallback logo
const DEFAULT_LOGO_URL = 'https://www.sracinc.org/images/sraclogo_resized.png';

interface LogoProps extends Omit<SVGProps<SVGSVGElement>, 'ref'> {
  /** Override the width (default: 50) */
  width?: number;
  /** Override the height (default: 50) */
  height?: number;
}

export function Logo({ className, width = 50, height = 50, ...props }: LogoProps) {
  const firestore = useFirestore();
  const [logoUrl, setLogoUrl] = useState<string>(DEFAULT_LOGO_URL);

  useEffect(() => {
    async function fetchLogoUrl() {
      try {
        // Fetch the clubLogoUrl field from membershipInfo
        const logoDoc = await getDoc(doc(firestore, 'membershipInfo', 'clubLogoUrl'));

        if (logoDoc.exists()) {
          const data = logoDoc.data();
          if (data?.value) {
            setLogoUrl(data.value);
          }
        }
      } catch (error) {
        console.error('Error fetching logo URL:', error);
        // Keep using the default logo
      }
    }

    fetchLogoUrl();
  }, [firestore]);

  return (
    <Image
      src={logoUrl}
      alt="SRAC Logo"
      width={width}
      height={height}
      className={cn('object-contain', className)}
    />
  );
}
